import { Check } from "lucide-react";

/**
 * Sitewide quality-control panel — six attributes laid out as 3 rows of 2
 * on desktop, oversized editorial type. Reads like a chunky spec sheet
 * baked onto the back of a hangtag.
 */
const ATTRIBUTES = [
  "The World's 847th Favourite Clothing Brand",
  "Fashion For People Who Don't Care",
  "Designed For Modern Leisure",
  "Socially Functional",
  "Garlic Sauce Resilient",
  "Occasionally Worn In Public",
];

export default function WCApproved({ tone = "dark", className = "" }) {
  const isDark = tone === "dark";
  const wrap = isDark
    ? "bg-[#F4F1E8] text-[#1A3626] border-y-2 border-[#1A3626]"
    : "bg-[#1A3626] text-[#EBE7DD] border-y-2 border-[#93C065]";
  const tickColor = "text-[#93C065]";

  return (
    <section
      className={`${wrap} ${className}`}
      aria-label="Wet Cabbage quality specifications"
      data-testid="wc-approved-strip"
    >
      <div className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6 sm:py-8 md:px-12 md:py-10 lg:py-12">
        <ul className="grid grid-cols-2 gap-x-4 gap-y-5 sm:gap-x-10 sm:gap-y-7 md:gap-x-14 md:gap-y-9 lg:gap-x-20 lg:gap-y-12">
          {ATTRIBUTES.map((attr, i) => (
            <li
              key={attr}
              className="flex items-center gap-2 sm:gap-4 md:gap-5 lg:gap-6"
              data-testid={`wc-approved-${i}`}
            >
              <Check
                className={`h-5 w-5 shrink-0 ${tickColor} sm:h-8 sm:w-8 md:h-9 md:w-9 lg:h-11 lg:w-11`}
                strokeWidth={3}
                aria-hidden
              />
              <span className="font-display text-[15px] font-black uppercase leading-[1.15] tracking-tight sm:text-2xl sm:leading-[1.05] md:text-3xl lg:text-4xl xl:text-[42px]">
                {attr}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
